'use client';

// import { useRouter } from 'next/navigation';
import { c as _c } from "react/compiler-runtime";
import { ItemDetail } from '@/components/ItemDetail';
import { useItem } from '@/lib/hooks';
import { useState } from 'react';
import { AddToCollectionModal } from '@/components/AddToCollectionModal';
import { ActivityFeed, ActivityOperations } from '@/components/activities';
import { ItemDetailSkeleton } from '@/components/ItemDetailSkeleton';
import { useSession } from '@/lib/auth-client';
interface ItemDetailViewProps {
  id: string;
  showReactions?: boolean;
  showComments?: boolean;
}
export default function ItemDetailView(props) {
  const $ = _c(33);
  const showActivityReactions = props.showReactions ?? false;
  const showActivityComments = props.showComments ?? false;
  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const {
    data: sessionData
  } = useSession();
  const isApproved = (sessionData?.user as any)?.approved === true;
  const {
    data: item,
    isLoading,
    error
  } = useItem(props.id);
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ItemDetailSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (error || !item) {
    let t0;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <div className="w-24 h-24 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center"><svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" /></svg></div>;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    const t1 = error ? "Error loading product" : "Product not found";
    let t2;
    if ($[2] !== t1) {
      t2 = <h1 className="text-2xl font-bold text-gray-900 mb-2">{t1}</h1>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    const t3 = error ? "Please try again later." : "The product you're looking for doesn't exist.";
    let t4;
    if ($[4] !== t3) {
      t4 = <p className="text-gray-600 mb-6">{t3}</p>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
      t5 = <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white flex items-center justify-center"><div className="text-center">{t0}{t2}{t4}</div></div>;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t0;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = itemId => {
      setSelectedItemId(itemId);
      setCollectionModalOpen(true);
    };
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  const handleAddToCollection = t0;
  let t1;
  if ($[10] !== item) {
    t1 = <ItemDetail item={item} onAddToCollection={handleAddToCollection} />;
    $[10] = item;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== item || $[13] !== showActivityReactions) {
    t2 = showActivityReactions && <ActivityOperations showVotes={false} objectId={item.id} objectType="item" dialogEnabled={true} title={item.title} />;
    $[12] = item;
    $[13] = showActivityReactions;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== isApproved || $[16] !== item || $[17] !== showActivityComments) {
    t3 = showActivityComments && <ActivityFeed canComment={isApproved} objectId={item.id} objectType="item" />;
    $[15] = isApproved;
    $[16] = item;
    $[17] = showActivityComments;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  let t4;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3) {
    t4 = <div className="space-y-12">{t1}{t2}{t3}</div>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setCollectionModalOpen(false);
      setSelectedItemId(null);
    };
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== item?.userCollections) {
    t6 = item?.userCollections || [];
    $[24] = item?.userCollections;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  let t7;
  if ($[26] !== collectionModalOpen || $[27] !== selectedItemId || $[28] !== t6) {
    t7 = <AddToCollectionModal isOpen={collectionModalOpen} onClose={t5} productId={selectedItemId} userCollections={t6} />;
    $[26] = collectionModalOpen;
    $[27] = selectedItemId;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  let t8;
  if ($[30] !== t4 || $[31] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[30] = t4;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
}